import React, { useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import SelectionState from "state/selections/SelectionState";
import { selectDefinitions } from "state/realizedGL/selectors";
import { setDefinition } from "state/realizedGL/actions";
import Checkbox from "@ls/react-checkbox";
import styled from "styled-components";
import RealizedGlDefinitions from "state/realizedGL/RealizedGlDefinitions";
import Switch from "@ls/react-switch";
import { selectGlPamValue } from "state/selections/selector";
import { setGlPam } from "state/selections/actions";
import { selectModeValue } from "state/selections/selector";
import Mode from "state/selections/Mode";
const Item = styled.div`
  padding: 5px;
  margin: 0 0 5px 0;
  background: #bfbfbf;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  border: 1px solid #a2a2a2;
  transition: box-shadow 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  &:hover {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  }
`;

const RowItem = styled.div`
  padding: 5px;
  margin: 0 0 5px 0;
  background: #bfbfbf;
  border-radius: 3px;
  display: flex;
  flex-direction: row;
  border: 1px solid #a2a2a2;
  transition: box-shadow 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  &:hover {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  }
`;

const RowParent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const RealizedGLSelector = () => {
  const definition = useSelector(
    selectDefinitions(SelectionState.UNCOMMITTED)
  )?.[0];
  const selectedModeValue = useSelector(
    selectModeValue(SelectionState.UNCOMMITTED)
  );
  const dispatch = useDispatch();

  const glPamValue = useSelector(selectGlPamValue(SelectionState.UNCOMMITTED));
  const onChangeGlPam = useCallback(
    (value) => dispatch(setGlPam(value)),
    [dispatch]
  );
  let _disabled = true;
  if (selectedModeValue === Mode.ENTITIES) {
    _disabled = false;
  }

  const [
    setRealizedGlMTD,
    setRealizedGlQTD,
    setRealizedGlYTD,
    setPerRealizedGlMTD,
    setPerRealizedGlQTD,
    setPerRealizedGlYTD,
    setRoiYTD,
  ] = useMemo(() => {
    return [
      (value) =>
        dispatch(
          setDefinition(
            0,
            definition
              ? definition.setRealizedGlMTD(value)
              : new RealizedGlDefinitions({ realizedGlMTD: true })
          )
        ),
      (value) =>
        dispatch(
          setDefinition(
            0,
            definition
              ? definition.setRealizedGlQTD(value)
              : new RealizedGlDefinitions({ realizedGlQTD: true })
          )
        ),
      (value) =>
        dispatch(
          setDefinition(
            0,
            definition
              ? definition.setRealizedGlYTD(value)
              : new RealizedGlDefinitions({ realizedGlYTD: true })
          )
        ),
      (value) =>
        dispatch(
          setDefinition(
            0,
            definition
              ? definition.setPerRealizedGlMTD(value)
              : new RealizedGlDefinitions({ perRealizedGlMTD: true })
          )
        ),
      (value) =>
        dispatch(
          setDefinition(
            0,
            definition
              ? definition.setPerRealizedGlQTD(value)
              : new RealizedGlDefinitions({ perRealizedGlQTD: true })
          )
        ),
      (value) =>
        dispatch(
          setDefinition(
            0,
            definition
              ? definition.setPerRealizedGlYTD(value)
              : new RealizedGlDefinitions({ perRealizedGlYTD: true })
          )
        ),
      (value) =>
        dispatch(
          setDefinition(
            0,
            definition
              ? definition.setRoiYTD(value)
              : new RealizedGlDefinitions({ roiYTD: true })
          )
        ),
    ];
  }, [definition, dispatch]);

  return (
    <>
      <RowParent>
        <div>
          <RowItem>
            <Item>
              <Checkbox
                label={"Realized G/L MTD"}
                value={definition?.realizedGlMTD ?? false}
                onChange={setRealizedGlMTD}
              />
            </Item>
            <Item>
              <Checkbox
                label={"Realized G/L QTD"}
                value={definition?.realizedGlQTD ?? false}
                onChange={setRealizedGlQTD}
              />
            </Item>
            <Item>
              <Checkbox
                label={"Realized G/L YTD"}
                value={definition?.realizedGlYTD ?? false}
                onChange={setRealizedGlYTD}
              />
            </Item>
          </RowItem>
          <RowItem>
            <Item>
              <Checkbox
                label={"% Realized G/L MTD"}
                value={definition?.perRealizedGlMTD ?? false}
                onChange={setPerRealizedGlMTD}
              />
            </Item>
            <Item>
              <Checkbox
                label={"% Realized G/L QTD"}
                value={definition?.perRealizedGlQTD ?? false}
                onChange={setPerRealizedGlQTD}
              />
            </Item>
            <Item>
              <Checkbox
                label={"% Realized G/L YTD"}
                value={definition?.perRealizedGlYTD ?? false}
                onChange={setPerRealizedGlYTD}
              />
            </Item>
          </RowItem>
        </div>

        <div style={{ marginLeft: "20px" }}>
          <Switch onChange={onChangeGlPam} value={glPamValue} label="G/L PAM" />
        </div>
      </RowParent>
      <div>
        <Item>
          <Checkbox
            label={"ROI YTD"}
            value={definition?.roiYTD ?? false}
            onChange={setRoiYTD}
            tooltip="Please select Entities Mode for ROI YTD Selection"
            disabled={_disabled}
          />
        </Item>
      </div>
    </>
  );
};

export default RealizedGLSelector;
